import classes from 'components/Header/Header.module.scss';
import CircularProgress from '@material-ui/core/CircularProgress';
import Constants from 'config/constants';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';

export default function Header(props) {
	const circularProgressTheme = createMuiTheme({
		palette: {
			primary: {
				main: props.pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? "#677406" : (props.pickupWebsite === Constants.COOKIE_PUBLIC_LANDS ? "#002A19" : "#BB5811")
			}
		}
	});

	return (
		<div className={classes.HeaderTileContainer} data-test-id="header-main">
			<div className={`${classes.HeaderCard} ${props.headerError && classes.DesktopErrorHeaderCard}`}>
				{props.promiseInProgress &&
				<div className={classes.CircularProgress}>
					<ThemeProvider theme={circularProgressTheme}>
						<CircularProgress />
					</ThemeProvider>
				</div>
				}
				<div className={!props.promiseInProgress ? classes.LogoTitleContainer : classes.HiddenLogoTitleContainer}>
					<div className={classes.IconContainer}>
						<img className={classes.IconImage} src={props.headerImage} alt="Status"/>
					</div>
					<div className={classes.Title} data-test-id="header-title">
						{props.headerTitle ?
							<h1 className={props.pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? 'titleGG' : (props.pickupWebsite === Constants.COOKIE_PUBLIC_LANDS ? 'titlePL' : 'titleDSG')}>{props.headerTitle}</h1>
							:
							<h1 className={props.pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? 'titleGG' : (props.pickupWebsite === Constants.COOKIE_PUBLIC_LANDS ? 'titlePL' : 'titleDSG')}>{Constants.DEFAULT_TITLE}</h1>
						}
					</div>
				</div>
				<div className={!props.promiseInProgress ? classes.Text : classes.HiddenText} data-test-id="header-message">
					{props.headerMessage ?
						<p className="body-medium">{props.headerMessage}</p>
						:
						<>
							{props.multiStore ?
								<>
									<p className="body-medium">{Constants.DEFAULT_MESSAGE_MULTI}</p>
								</>
								:
								<>
									<p className="body-medium">{Constants.DEFAULT_MESSAGE}</p>
								</>
							}
						</>
					}
					{/*
					{props.extend && !props.pickedUp &&
					<div className={classes.ViewOrderLink} data-test-id="header-view-order-link">
						<p className={`link-text ${props.pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? "link-hover-gg" : (props.pickupWebsite === Constants.COOKIE_PUBLIC_LANDS ? "link-hover-pl" : "link-hover-dsg")}`}
							onClick={() => window.open(`https://${new URL(window.location.href).hostname}/TrackOrder?orderId=${props.orderNumber}&zipCode=${props.zipCode}`, '_blank')}>
							View Order</p>
					</div>
					}
					*/}
				</div>
			</div>
		</div>
	);
}
